const Order = () =>
  import(
    /* webpackChunkName: "system-setting-order" */ '@/pages/system/setting/order.vue'
  )

export default {
  path: 'order',
  meta: {
    label: 'order',
    auth: 'order'
  },
  component: {
    name: 'Order',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemSettingOrder',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Order
    }
  ]
}
